import { useThemePrimaryTagsQuery } from "entities/themeTagTypes/queries/useThemePrimaryTagsQuery";
import { xorBy } from "lodash";
import { useState, MouseEvent, useMemo } from "react";
import { FilterOption } from "shared/components/Filter";
import { useAnchorEl } from "shared/hooks/useAnchorEl";
import { FilterHook } from "../../../../../../types";

export const useThemeTagTypeFilter = (): FilterHook => {
  const [selectedMultipleTagTypes, setSelectedMultipleTagTypes] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);

  const { open, handleAnchorClose, handleAnchorOpen, anchorEl } = useAnchorEl();

  const { data: themePrimaryTags = [], isFetching } =
    useThemePrimaryTagsQuery();

  const options = useMemo(
    () =>
      themePrimaryTags.map((product) => ({
        label: product.name,
        value: product.id.toString(),
      })),
    [themePrimaryTags],
  );

  const handleChangeValue = (
    _: MouseEvent<HTMLElement>,
    option: FilterOption,
  ) => {
    setSelectedMultipleTagTypes((prev) => xorBy(prev, [option], "value"));
  };

  const onClearSelectedValues = () => setSelectedMultipleTagTypes([]);

  return {
    filteredValues: selectedMultipleTagTypes.map((item) => item.value) ?? [],
    setFilteredValues: setSelectedMultipleTagTypes,
    filterData: {
      options,
      anchorEl,
      open,
      selectedValue: selectedMultipleTagTypes,
      handleOpenMenu: handleAnchorOpen,
      handleChangeValue,
      handleClose: handleAnchorClose,
      onClearSelectedValues,
    },
    isDisabledButton: isFetching,
  };
};
